import React from 'react';
import DepositBalanceCard from './components/DepositBalanceIndex.jsx';

const DepositBalance = ({program}) => {
  return (
      <DepositBalanceCard program={program} />
  )
}

export default DepositBalance;
